export default __webpack_public_path__ + "static/media/J_wdt_c_cap_3.37ac6590.mp3";